import React from 'react';

const refreshAccessToken = async () => {
    const refreshToken = localStorage.getItem("refresh_token");
    if (!refreshToken) {
      throw new Error("No refresh token found");
    }

    try {
      const response = await fetch("api/users/refresh-token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: refreshToken }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.ok) {
            localStorage.setItem("access_token", data.token);
            return data.token;
        } else {
            throw new Error("Failed to refresh access token");
        }
      } else {
        throw new Error("Failed to refresh access token");
      }
    } catch (error) {
      throw error;
    }
  };


const withTokenRefresh = async (fetchFunction, ...args) => {
    try {
      return await fetchFunction(...args);
    } catch (error) {
        if (error.message === "Failed to fetch protected data" || error.message === "No token found. Please log in." || error.message === "Network error") {
        console.error("Access token expired. Refreshing...");
        await refreshAccessToken();
        // Retry the fetch function with the new token
        return await fetchFunction(...args);
      }

      throw error; // Re-throw any other errors
    }
  };

export default withTokenRefresh;
